import React, { useEffect, useState, useRef } from "react";
import JaqkCoin from "../../assets/images/jaqk-coin.svg";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { getUserLoyalty } from "../signIn/cl_SignInSlice";
import { Affliliate_site } from "./Affliliate_site";
import { LevelModal } from "./LevelModal";
import { setIsmodalOpen } from "../home/cl_LoyalltyCoins";
import ReferalBonus from "./ReferalBonus";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import BackIcon from "../../assets/images/sprite-other-icons.svg";
import FooterLogo from "../../assets/images/logo-header.svg";
import icons from "../../assets/images/sprite-other-icons.svg";

const Loyalty = () => {
  const [loading, setLoading] = useState(true);
  const { userDetails, userLoyalty } = useSelector((state) => state?.signIn);
  const topRef = useRef(null);
  useEffect(() => {
    if (topRef.current && topRef.current.scrollTo) {
      topRef.current.scrollTo(0, 0);
    }
  }, []);
  useEffect(() => {
    // Delay to ensure DOM is rendered before scrolling
    const timeout = setTimeout(() => {
      if (typeof window !== "undefined" && window.scrollTo) {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    }, 100); // 100ms is usually enough

    return () => clearTimeout(timeout);
  }, []);
  const { isModalOpen } = useSelector((state) => state?.coinsHistory);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [isModalOpen, setIsmodalOpen] = useState(false);
  const totalCoins = userLoyalty?.lifeTimeCoins;
  const token = getFromLocalStorage("gk");

  useEffect(() => {
    if (userDetails?.userId) {
      dispatch(getUserLoyalty(userDetails?.userId));
    }
  }, [userDetails?.userId]);

  useEffect(() => {
    // Simulate data fetching or wait for your actual data to load
    // If you use Redux, check for the loading state from the store instead
    setTimeout(() => {
      setLoading(false);
    }, 500); // Replace with your real data loading logic
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="spinner" /> {/* Use your spinner or skeleton here */}
      </div>
    );
  }

  if (!token) {
    return (
      <div className="SB-mainSection">
        <div
          className="SB-mainSection-content"
          style={{ height: "calc(-162px + 100dvh)" }}
        >
          <div className="SB-page-content" ref={topRef}>
            <div className="SB-myAccountSection-container SB-loyalty">
              <div className="SB-pageHeader">
                <div className="SB-pageBackButton" onClick={() => navigate(-1)}>
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-back"}`} />
                    </svg>
                  </div>
                </div>
                <div className="SB-pageHeader-title">Loyalty</div>
              </div>
              <div className="SB-content">
                <div className="SB-userLevel">
                  <div className="SB-userLevel-Card step-1">
                    <div className="SB-userLevel-Badge">
                      <img
                        src={require("../../assets/images/loyalty/dash.webp")}
                        alt="dash"
                      />
                    </div>
                    <div className="SB-userLevel-Content">
                      <div className="SB-userLevel-points">
                        Loyalty Coins
                        <span>
                          <img src={JaqkCoin} alt="coin" />0
                        </span>
                      </div>
                      <p>Earn 200 LP to unlock the next Level</p>
                    </div>
                  </div>
                </div>

                <div className="SB-loyaltyLevel__content">
                  <ul>
                    <li>Fasfas games, A fashta gaming experience for all.</li>
                    <li>
                      Every game played* is an opportunity to race ahead the
                      Loyalty tiers earn Fasfas coins Fashta.
                    </li>
                    <li>
                      Start your journey with <strong>DASH</strong>, where
                      initial bonuses* get you in the game and keep the energy
                      high.
                    </li>
                    <li>
                      Speed up to <strong>SPRINT</strong>, where every bet
                      boosts you closer to bigger rewards.
                    </li>
                    <li>
                      The excitement intensifies at <strong>SURGE</strong>,
                      where momentum turns into accelerated benefits.
                    </li>
                    <li>
                      Reach new heights with <strong>THRILL</strong> where speed
                      and excitement combine for bigger rewards.
                    </li>
                    <li>
                      Finally, claim your crown as the{" "}
                      <strong>FASFAS BOSS</strong>, the ultimate VIP tier. As
                      the Boss, you unlock unmatched exclusivity, elite rewards
                      including your own microsite, invite your gaming army to
                      play your favorite games and earn thrilling
                      rewards*..Everything Fashta
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="SB-page-content" ref={topRef}>
      <div className="SB-myAccountSection-container SB-loyalty">
        <div className="SB-pageHeader">
          <div className="SB-pageHeader-title">Loyalty</div>
        </div>
        <div className="SB-content">
          <div className="SB-userLevel">
            <div
              className={`SB-userLevel-Card  ${
                userLoyalty?.lifeTimeCoins <=
                LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                  .levelCutoff
                  ? "step-1"
                  : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                      .levelCutoff
                  ? "step-2"
                  : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                      .levelCutoff
                  ? "step-3"
                  : userLoyalty?.lifeTimeCoins <=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                      .levelCutoff
                  ? "step-4"
                  : userLoyalty?.lifeTimeCoins >=
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                      .levelEntry
                  ? "step-5 vipImg"
                  : ""
              }`}
            >
              <div className="SB-userLevel-Badge">
                {userLoyalty?.lifeTimeCoins <=
                LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                  .levelCutoff ? (
                  <img
                    src={require("../../assets/images/loyalty/dash.webp")}
                    alt="dash"
                  />
                ) : userLoyalty?.lifeTimeCoins <=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                    .levelCutoff ? (
                  <img
                    src={require("../../assets/images/loyalty/sprint.webp")}
                    alt="sprint"
                  />
                ) : userLoyalty?.lifeTimeCoins <=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                    .levelCutoff ? (
                  <img
                    src={require("../../assets/images/loyalty/surge.webp")}
                    alt="surge"
                  />
                ) : userLoyalty?.lifeTimeCoins <=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                    .levelEntry ? (
                  <img
                    src={require("../../assets/images/loyalty/thrill.webp")}
                    alt="thrill"
                  />
                ) : userLoyalty?.lifeTimeCoins >=
                  LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                    .levelEntry ? (
                  <img
                    src={require("../../assets/images/loyalty/boss.webp")}
                    alt="boss"
                  />
                ) : (
                  ""
                )}
              </div>
              {userLoyalty.level === "level4" ? (
                <div className="SB-userLevel-Content">
                  <div className="SB-userLevel-Heading">
                    Congratulations!
                    <p>You've reached the BOSS level!</p>
                  </div>
                  <div className="SB-userLevel-points">
                    Available Loyalty Coins
                    <span>
                      <img src={JaqkCoin} alt="coin" />
                      {userLoyalty?.coins > 0
                        ? Math.floor(userLoyalty?.coins).toLocaleString()
                        : 0}
                    </span>
                  </div>
                  <div className="SB-userLifeTime-points">
                    Lifetime Loyalty Coins
                    <span>
                      <img src={JaqkCoin} alt="coin" />
                      {userLoyalty?.coins > 0
                        ? Math.floor(userLoyalty?.lifeTimeCoins).toLocaleString()
                        : 0}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="SB-userLevel-Content">
                  <div className="SB-userLevel-points">
                    Available Loyalty Coins
                    <span>
                      <img src={JaqkCoin} alt="coin" />
                      {userLoyalty?.coins > 0
                        ? Math.floor(userLoyalty?.coins).toLocaleString()
                        : 0}
                    </span>
                  </div>
                  <div className="SB-userLifeTime-points">
                    Lifetime Loyality Coins
                    <span>
                      <img src={JaqkCoin} alt="coin" />
                      {userLoyalty?.coins > 0
                        ? Math.floor(userLoyalty?.lifeTimeCoins).toLocaleString
                        : 0}
                    </span>
                  </div>

                  <p>
                    Earn{" "}
                    {userLoyalty?.lifeTimeCoins <
                    LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                      .levelEntry
                      ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelEntry - totalCoins
                      : userLoyalty?.lifeTimeCoins <
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelEntry
                      ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelEntry - totalCoins
                      : userLoyalty?.lifeTimeCoins <
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .levelEntry
                      ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .levelEntry - totalCoins
                      : userLoyalty?.lifeTimeCoins <
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry
                      ? LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry - totalCoins
                      : ""}{" "}
                    Loyalty Coins to unlock the next Level
                  </p>
                </div>
              )}
            </div>
          </div>

          {isModalOpen && userLoyalty?.lifeTimeCoins > 0 && <LevelModal />}

          {userLoyalty?.lifeTimeCoins <
            LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
              .levelEntry && (
            <div className="SB-userLevel-steps">
              <ul>
                <li className={`${
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0].levelCutoff ? 'completed' : ''
                } ${
                  userLoyalty?.lifeTimeCoins <= LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0].levelCutoff ? 'active' : ''
                }`}>
                  <img src={require("../../assets/images/loyalty/dash.webp")} alt="dash" />
                  <div className="SB-steps-label">On Signup</div>
                </li>
                <li className={`${
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1].levelCutoff ? 'completed' : ''
                } ${
                  userLoyalty?.lifeTimeCoins <= LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1].levelCutoff &&
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0].levelCutoff ? 'active' : ''
                }`}>
                  <img src={require("../../assets/images/loyalty/sprint.webp")} alt="sprint" />
                  <div className="SB-steps-label">300 Coins</div>
                </li>
                <li className={`${
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2].levelCutoff ? 'completed' : ''
                } ${
                  userLoyalty?.lifeTimeCoins <= LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2].levelCutoff &&
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1].levelCutoff ? 'active' : ''
                }`}>
                  <img src={require("../../assets/images/loyalty/surge.webp")} alt="surge" />
                  <div className="SB-steps-label">1000 Coins</div>
                </li>
                <li className={`${
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3].levelCutoff ? 'completed' : ''
                } ${
                  userLoyalty?.lifeTimeCoins <= LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3].levelCutoff &&
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2].levelCutoff ? 'active' : ''
                }`}>
                  <img src={require("../../assets/images/loyalty/thrill.webp")} alt="thrill" />
                  <div className="SB-steps-label">3000 Coins</div>
                </li>
                <li className={`${
                  userLoyalty?.lifeTimeCoins > LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4].levelEntry ? 'completed' : ''
                } ${
                  userLoyalty?.lifeTimeCoins >= LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4].levelEntry ? 'active' : ''
                }`}>
                  <img src={require("../../assets/images/loyalty/boss.webp")} alt="boss" />
                  <div className="SB-steps-label">5000 Coins</div>
                </li>
              </ul>
            </div>
          )}
          {userLoyalty?.lifeTimeCoins >
          LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4].levelEntry ? (
            <Affliliate_site />
          ) : (
            <>
              <div className="SB-playGames">
                <p>Play games to earn Loyalty Coins</p>
                <button
                  className="btn SB-btnSecondary active SB-btnplayNow"
                  onClick={() => navigate("/")}
                >
                  Play Now
                </button>
              </div>
            </>
          )}
          <div className="SB-myAccount-sectionBox SB-loyalty-benefits">
            <div className="SB-myAccount-sectionBox_header">
              Loyalty Benefits
            </div>
            <div className="SB-userLevel-table SB-table-scrollable">
              <table>
                <colgroup>
                  <col />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                        .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins >=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                        .levelEntry
                        ? "active"
                        : ""
                    }
                  />
                </colgroup>
                <thead>
                  <tr>
                    <td></td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/dash.webp")}
                        alt="dash"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/sprint.webp")}
                        alt="sprint"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/surge.webp")}
                        alt="surge"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/thrill.webp")}
                        alt="thrill"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/boss.webp")}
                        alt="boss"
                      />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="SB-tbody-tableHeader">
                    {/* <td>Earn FasFas Coins</td> */}
                  </tr>
                  <tr>
                    <td>Tier Cutoff (coins) </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .levelEntry
                      }{" "}
                      -{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .levelCutoff
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelEntry
                      }{" "}
                      -{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff
                      }
                    </td>
                    <td>
                      {
                        Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelEntry).toLocaleString()
                      }{" "}
                      -{" "}
                      {
                        Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff).toLocaleString()
                      }
                    </td>
                    <td>
                      {
                        Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .levelEntry).toLocaleString()
                      }{" "}
                      -{" "}
                      {
                        Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .levelCutoff).toLocaleString()
                      }
                    </td>
                    <td>
                      {
                        Number(LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry).toLocaleString()
                      }
                      +
                    </td>
                  </tr>
                  <tr>
                    <td> Signup</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins.signup
                          .level0
                      }
                    </td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                  </tr>

                  <tr>
                    <td>1st Deposit</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .firstdeposit.level0.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .firstdeposit.level0.max
                      }
                    </td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                  </tr>
                  <tr>
                    <td>2nd Deposit</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level0.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level0.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level1.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level1.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level2.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level2.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level3.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level3.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level4.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .seconddeposit.level4.max
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>3rd Deposit</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level0.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level0.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level1.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level1.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level2.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level2.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level3.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level3.max
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level4.percent
                      }
                      % upto{" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyCoins
                          .thirddeposit.level4.max
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>For every 100 KES lost </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                          .betlost[0].c1.level0
                      }
                    </td>
                    <td>
                      {" "}
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                          .betlost[0].c1.level1
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                          .betlost[0].c1.level2
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                          .betlost[0].c1.level3
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyCoins
                          .betlost[0].c1.level4
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Min Redeem Coins</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .minBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .minBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .minBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .minBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .minBurnCoins
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>Max Redeem Coins</td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .maxBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .maxBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .maxBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[3]
                          .maxBurnCoins
                      }
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .maxBurnCoins
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Redemption: Cash</strong>
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[0]
                          .realCashPercentage
                      }
                      %
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[1]
                          .realCashPercentage
                      }
                      %
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[2]
                          .realCashPercentage
                      }
                      %
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[3]
                          .realCashPercentage
                      }
                      %
                    </td>
                    <td>
                      {
                        LoyaltyConfig.loyaltyPointsConfig[0].loyaltyLevels[4]
                          .realCashPercentage
                      }
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <ReferalBonus showTable={"yes"} />
        </div>
      </div>
    </div>
  );
};

export default Loyalty;
